module.exports = __webpack_public_path__ + "static/media/privacyPolicy.80daa34f.pdf";